export default class MedicalSituationAdmission {
  month: string
  year: string
  reason: string

  constructor({ month, year, reason }: Partial<MedicalSituationAdmission> = {}) {
    this.month = month ?? ''
    this.year = year ?? ''
    this.reason = reason ?? ''
  }
}
